import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';

import { setStep } from '~/src/features/tariffBuilder/actions';
import { useConstructorAnalytics } from '~/src/features/tariffBuilder/analytics/hooks/useConstructorAnalytics';
import InternetSpeedBlock from '~/src/features/tariffBuilder/components/InternetSpeedBlock';
import OnlineCinemasBlock from '~/src/features/tariffBuilder/components/OnlineCinemasBlock';
import Section from '~/src/features/tariffBuilder/components/Section';
import TvBlock from '~/src/features/tariffBuilder/components/TvBlock';
import { useCtxDispatch, useCtxSelector } from '~/src/features/tariffBuilder/hooks';
import selectIsShowTvBlock from '~/src/features/tariffBuilder/selectors/selectIsShowTvBlock';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';
import { ESteps } from '~/src/features/tariffBuilder/types/ESteps';

const SpeedAndTv = (): JSX.Element => {
    const dispatch = useCtxDispatch();

    const { entityDescription, isShowTvBlock } = useCtxSelector(state => ({
        entityDescription: state.entityDescription,
        isShowTvBlock: selectIsShowTvBlock(state),
    }));

    const analytics = useConstructorAnalytics();

    const handleButtonClick = () => {
        dispatch(setStep(ESteps.Subscriptions));
        analytics.clickedMoveToSubscription();
    };

    return (
        <>
            <Section>
                <InternetSpeedBlock />
            </Section>

            <Section>
                <OnlineCinemasBlock {...entityDescription[EEntity.onlineCinemas]}/>
            </Section>

            {isShowTvBlock && (
                <Section>
                    <TvBlock />
                </Section>
            )}

            <ButtonGroup>
                <Button bType={'action'} onClick={handleButtonClick}>Перейти к выбору подписок</Button>
            </ButtonGroup>
        </>
    );
};

export default SpeedAndTv;
